export const SET_COMPANIES_FILTERS = 'SET_COMPANIES_FILTERS';

export const setCompiesFilters = ({ name = '', identifier = '' } = {}) => ({
    type: SET_COMPANIES_FILTERS,
    payload: {
        name,
        identifier
    }
});
